import React from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import { EDIT_ROLES, CUSTOMER_EDIT_ROLES, ROLES, PRODUCTION_VIEW_ROLES } from '../constants';
import type { User } from '../types/user';

interface AuthState {
  user: User | null;
  userName: string;
  userEmail: string;
  userRole: string;
  userProfilUrl: string;
  isAuthenticated: boolean;
  isAdmin: boolean;
  isOperasyon: boolean;
  isGoruntuleme: boolean;
  isMuhasebe: boolean;
  isTeknik: boolean;
  isProductionView: boolean;
  canEdit: boolean;
  canCreate: boolean;
  canDelete: boolean;
  canEditOrders: boolean;
  canEditCustomers: boolean;
}

export const useAuth = (): AuthState => {
  const { user, isAuthenticated } = useAuthContext();

  const userRole = (user?.rol || '').toLowerCase();

  const isAdmin = userRole === ROLES.ADMIN;
  const isOperasyon = userRole === ROLES.OPERASYON;
  const isGoruntuleme = userRole === ROLES.GORUNTULEME;
  const isMuhasebe = userRole === ROLES.MUHASEBE;
  const isTeknik = userRole === ROLES.TEKNIK;
  const isProductionView = PRODUCTION_VIEW_ROLES.includes(userRole);
  const canEdit = EDIT_ROLES.includes(userRole);
  const canEditOrders = canEdit || isTeknik; // [TEKNİK] sipariş düzenleme operasyon seviyesinde
  // Müşteri kaydı yazma — pazarlama dahil (rota 3.39). Birleştirme, siparişe bilgi
  // yansıtma ve müşterinin ticari alanları bununla değil `canEdit` ile açılır.
  const canEditCustomers = CUSTOMER_EDIT_ROLES.includes(userRole);

  return {
    user,
    userName: user?.ad || '',
    userEmail: user?.email || '',
    userRole,
    userProfilUrl: user?.profil_url || '',
    isAuthenticated,
    isAdmin,
    isOperasyon,
    isGoruntuleme,
    isMuhasebe,
    isTeknik,
    isProductionView,
    canEdit,
    canCreate: canEdit,
    canDelete: isAdmin,
    canEditOrders,
    canEditCustomers
  };
};

interface RequireRoleProps {
  roles: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const RequireRole: React.FC<RequireRoleProps> = ({
  roles,
  children,
  fallback = null
}) => {
  const { userRole } = useAuth();

  if (!roles.includes(userRole)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
